const RELOAD_TIMER = 300;
const SP_OBJECT = {
  ajxcartRefresh: 'cart-update',
  qtyRefresh: 'quantity-update',
  swatchUpdate: 'variant-change'
};
let users = {}
function user(eventName, callback) {
  if (users[eventName] === undefined) {
    users[eventName] = []
  }
  users[eventName] = [...users[eventName], callback];
  return function unuser() {
    users[eventName] = users[eventName].filter((cb) => {
      return cb !== callback
    });
  }
};
function live(eventName, data) {
  if (users[eventName]) {
    users[eventName].forEach((callback) => {
      callback(data)
    })
  }
}
function animate() {
  document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
}
['load', 'scroll', 'resize'].forEach(eventName => window.addEventListener(eventName, animate));
function getClickable(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
const getScrollTop = (element) => {
  let offsetTop = 0
  do {
    if (!isNaN(element.offsetTop)) {
      offsetTop += element.offsetTop
    }
  } while ((element = element.offsetParent))
  return offsetTop
}
const portView = (element) => {
  const windowBottom = window.pageYOffset + window.innerHeight;
  return windowBottom >= getScrollTop(element);
}
if (!window.Shopify.designMode) {
  document.querySelectorAll('[data-fade-in]').forEach((element) => {
    ['load', 'scroll', 'shopify:section:load'].forEach((eventName) => {
      window.addEventListener(eventName, () => {
        if (!portView(element)) {
          return;
        }
        element.classList.add('fade-in');
      })
    })
  })
}
const triggerClickFocus = {};
function triggerClick(container, tagClicked = container) {
  if (!container) return;
  var elements = getClickable(container);
  if (!elements.length) {
    if (tagClicked && typeof tagClicked.focus === 'function') tagClicked.focus();
    return;
  }
  var first = elements[0];
  var last = elements[elements.length - 1];
  triggerClickClose();
  triggerClickFocus.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;
    document.addEventListener('keydown', triggerClickFocus.keydown);
  };
  triggerClickFocus.focusout = function () {
    document.removeEventListener('keydown', triggerClickFocus.keydown);
  };
  triggerClickFocus.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }
    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };
  document.addEventListener('focusout', triggerClickFocus.focusout);
  document.addEventListener('focusin', triggerClickFocus.focusin);
  tagClicked.focus();
  if (tagClicked.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(tagClicked.type) &&
    tagClicked.value) {
    tagClicked.setSelectionRange(0, tagClicked.value.length);
  }
}
// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  triggerShow();
}
function triggerShow() {
  const keyCont = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let nowClickedTag = null;
  let clickCont = null;
  window.addEventListener('keydown', (event) => {
    if (keyCont.includes(event.code.toUpperCase())) {
      clickCont = false;
    }
  });
  window.addEventListener('mousedown', (event) => {
    clickCont = true;
  });
  window.addEventListener('focus', () => {
    if (nowClickedTag) nowClickedTag.classList.remove('focused');
    if (clickCont) return;
    nowClickedTag = document.activeElement;
    nowClickedTag.classList.add('focused');
  }, true);
}
function triggerClickClose(tagClicked = null) {
  document.removeEventListener('focusin', triggerClickFocus.focusin);
  document.removeEventListener('focusout', triggerClickFocus.focusout);
  document.removeEventListener('keydown', triggerClickFocus.keydown);
  if (tagClicked) tagClicked.focus();
}
function escClick(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;
  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;
  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}
class qtyBox extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    if (!this.input) return;
    this.input.addEventListener('change', this.qtyInputupdate.bind(this));
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.BtTrigger.bind(this))
    );
  }
  qtyInputupdateBlank = undefined;
  connectedCallback() {
    this.requreQtyterm();
    this.qtyInputupdateBlank = user(SP_OBJECT.qtyRefresh, this.requreQtyterm.bind(this));
  }
  disconnectedCallback() {
    if (this.qtyInputupdateBlank) {
      this.qtyInputupdateBlank();
    }
  }
  qtyInputupdate(event) {
    this.requreQtyterm();
  }
  BtTrigger(event) {
    event.preventDefault();
    const button = event.target.closest('button');
    if (!button) return;
    
    const pastValue = parseInt(this.input.value) || 0;
    const isPlus = button.getAttribute('name') === 'plus';
    const min = parseInt(this.input.min) || 0;
    const max = parseInt(this.input.max) || Infinity;
    const step = parseInt(this.input.step) || 1;
    
    let newValue = isPlus ? pastValue + step : pastValue - step;
    
    // Bounds checking
    if (newValue < min) newValue = min;
    if (newValue > max) newValue = max;
    
    if (pastValue !== newValue) {
      this.input.value = newValue;
      this.input.dispatchEvent(this.changeEvent);
      this.requreQtyterm(); // Update disabled state of buttons
    }
  }
  requreQtyterm() {
    if (!this.input) return;
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const qtyDecrease = this.querySelector(".qty-bt[name='minus']");
      if (qtyDecrease) qtyDecrease.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const qtyIncrease = this.querySelector(".qty-bt[name='plus']");
      if (qtyIncrease) qtyIncrease.classList.toggle('disabled', value >= max);
    }
  }
}
customElements.define('qty-box', qtyBox);
function stdebounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
function stFetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}
Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};
Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};
Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};
Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};
  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);
  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};
Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);
  if (!this.countryEl || !this.provinceEl || !this.provinceContainer) return;
  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));
  this.initCountry();
  this.initProvince();
};
Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },
  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },
  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);
    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }
      this.provinceContainer.style.display = "";
    }
  },
  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },
  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};
class stModalcontent extends HTMLElement {
  constructor() {
    super();
    const closeButton = this.querySelector('[id^="stclose-"]');
    if (closeButton) {
      closeButton.addEventListener(
        'click',
        this.hide.bind(this, false)
      );
    }
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }
  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }
  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    triggerClick(this, this.querySelector('[role="dialog"]') || this);
  }
  hide() {
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    triggerClickClose(this.openedBy);
  }
}
customElements.define('modal-dialog', stModalcontent);
class stModalshower extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('a');
    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('qv-modal', stModalshower);
class Swatchoption extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.swatchUpdate);
  }
  swatchUpdate() {
    this.itemsUpdate();
    this.stupdateMasterId();
    this.btAddButton(true, '', false);
    this.stErrortxtRemove();
    this.updateSwatchStatuses();
    if (!this.swatch) {
      this.btAddButton(true, '', true);
      this.stInaccessible();
    } else {
      this.stupdateURL();
      this.changeSwatchInput();
      this.includeProInf();
      this.updateDiscount();
      this.updateImage();
    }
  }
  updateImage() {
    ///console.log(this.swatch);
    if (this.swatch.featured_image != null) {
      var product_id = this.swatch.featured_image.product_id;
      var section_id = this.getAttribute("data-section");
      if (this.swatch && this.swatch.featured_image) {
        if (jQuery('.pro_details_pos .swiper-slide').length >= 1) {
          var layout = jQuery('#slider-small-' + section_id + '-' + product_id + ' .swiper-slide[data-image-id="' + this.swatch.featured_media.id + '"]').attr('data-layout');
          if (layout == "full-slider") {
            var swiper = new Swiper(".slider-small-" + section_id + "-" + product_id, {
              spaceBetween: 15,
              slidesPerView: 3,
              navigation: {
                nextEl: ".button-next",
                prevEl: ".button-prev"
              },
              breakpoints: {
                0: {
                  slidesPerView: 1,
                },
                320: {
                  slidesPerView: 1,
                },
                480: {
                  slidesPerView: 3,
                },
              }
            });
            const unGroupMedia = document.querySelector(`#slider-small-` + section_id + `-` + product_id + ` .swiper-slide[data-image-id="` + this.swatch.featured_media.id + `"]`);
            if (!unGroupMedia) return;
            const mediaIndex = unGroupMedia.getAttribute('data-index');
            if (mediaIndex == 1) {
              swiper.destroy();
              var swiper = new Swiper(".slider-small-" + section_id + "-" + product_id, {
                spaceBetween: 15,
                slidesPerView: 3,
                navigation: {
                  nextEl: ".button-next",
                  prevEl: ".button-prev"
                },
                breakpoints: {
                  0: {
                    slidesPerView: 1,
                  },
                  320: {
                    slidesPerView: 1,
                  },
                  480: {
                    slidesPerView: 3,
                  },
                }
              });
            } else {
              var new_index = parseInt(mediaIndex) - 1;
              swiper.slideTo(new_index, 500, true);
            }
          } else {
            var slider_pos = jQuery('#slider-small-' + section_id + '-' + product_id + ' .swiper-slide[data-image-id="' + this.swatch.featured_media.id + '"]').attr('data-slide');
            if (slider_pos == 'vertical') {
              var dr = 'vertical';
              var sv = 'auto';
            } else {
              var dr = 'horizontal';
              var sv = 5;
            }
            var swiper = new Swiper(".slider-small-" + section_id + "-" + product_id, {
              spaceBetween: 15,
              slidesPerView: sv,
              direction: dr,
              mousewheel: true,
              slideToClickedSlide: true,
              autoHeight: true,
              breakpoints: {
                0: {
                  slidesPerView: 3,
                  direction: 'horizontal'
                },
                320: {
                  slidesPerView: 3,
                  direction: 'horizontal'
                },
                480: {
                  slidesPerView: sv,
                  direction: dr,
                },
              }
            });
            var swiper2 = new Swiper(".slider-big-" + section_id + "-" + product_id, {
              spaceBetween: 0,
              slidesPerView: 1,
              autoHeight: true,
              slideToClickedSlide: true,
              navigation: {
                nextEl: ".button-next",
                prevEl: ".button-prev"
              },
              thumbs: {
                swiper: swiper,
              },
            });
            const unGroupMedia = document.querySelector(`#slider-small-` + section_id + `-` + product_id + ` .swiper-slide[data-image-id="` + this.swatch.featured_media.id + `"]`);
            if (!unGroupMedia) return;
            // console.log(unGroupMedia.realIndex);
            const mediaIndex = unGroupMedia.getAttribute('data-index');
            //alert(mediaIndex);
            if (mediaIndex == 1) {
              swiper2.destroy();
              var swiper2 = new Swiper(".slider-big-" + section_id + "-" + product_id, {
                spaceBetween: 0,
                slidesPerView: 1,
                autoHeight: true,
                slideToClickedSlide: true,
                loop: false,
                navigation: {
                  nextEl: ".button-next",
                  prevEl: ".button-prev"
                },
                thumbs: {
                  swiper: swiper,
                },
              });
            } else {
              var new_index = parseInt(mediaIndex) - 1;
              swiper2.slideTo(new_index, 500, true);
            }
          }
        }
      }
    }
  }
  updateDiscount() {
    const sectionId = this.dataset.section;
    const productInfo =
      document.getElementById(`ProductInfo-${sectionId}`) ||
      this.closest('.product__info-container') ||
      document;
    const productDiscount = productInfo.querySelector('#ProductDiscount');
    const productLabel = productInfo.querySelector('.product-label');
    const compareAtPrice = Number(this.swatch && this.swatch.compare_at_price ? this.swatch.compare_at_price : 0);
    const price = Number(this.swatch && this.swatch.price ? this.swatch.price : 0);
    const hasValidCompareAtPrice = Number.isFinite(compareAtPrice) && compareAtPrice > 0;
    const hasValidPrice = Number.isFinite(price) && price > 0;

    if (!productDiscount || !productLabel) return;

    if (hasValidCompareAtPrice && hasValidPrice && compareAtPrice > price) {
      const percentage = Math.round(((compareAtPrice - price) * 100) / compareAtPrice);
      if (Number.isFinite(percentage) && percentage > 0) {
        productDiscount.textContent = `-${percentage}%`;
        productDiscount.style.display = '';
        productLabel.style.display = 'block';
        return;
      }
    }

    productDiscount.textContent = '';
    productDiscount.style.display = 'none';
    productLabel.style.display = 'none';
  }
  itemsUpdate() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }
  stupdateMasterId() {
    this.swatch = this.stSwatchDate().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }
  stupdateURL() {
    if (!this.swatch || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.swatch.id}`);
  }
  changeSwatchInput() {
    const stproductForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-sticky-${this.dataset.section}`);
    stproductForms.forEach((stproductForm) => {
      const input = stproductForm.querySelector('input[name="id"]');
      if (!input) return;
      input.value = this.swatch.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  updateSwatchStatuses() {
    const activeInput = this.querySelector(':checked');
    if (!activeInput) return;
    const activatedSwatch = this.variantData.filter(variant => activeInput.value === variant.option1);
    const stinputWrappers = [...this.querySelectorAll('.op-field')];
    stinputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const stoptionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const pastSelectedInput = stinputWrappers[index - 1].querySelector(':checked');
      if (!pastSelectedInput) return;
      const pastOptionSelected = pastSelectedInput.value;
      const avOptionInVal = activatedSwatch.filter(variant => variant.available && variant[`option${index}`] === pastOptionSelected).map(variantOption => variantOption[`option${index + 1}`]);
      this.stInAva(stoptionInputs, avOptionInVal)
    });
  }
  stInAva(stlistOfOptions, stlistOfAvOptions) {
    stlistOfOptions.forEach(input => {
      if (stlistOfAvOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.stThemeString.StrunavailableOp.replace('[value]', input.getAttribute('value'));
      }
    });
  }
  stErrortxtRemove() {
    const section = this.closest('section');
    if (!section) return;
    const stproductForm = section.querySelector('cart-action');
    if (stproductForm) stproductForm.stHandErrorTxt();
  }
  includeProInf() {
    const reqSwatchId = this.swatch.id;
    const stScId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    fetch(`${this.dataset.url}?variant=${reqSwatchId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.swatch.id !== reqSwatchId) return;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const goal = document.getElementById(`price-${this.dataset.section}`);
        const goalUnit = document.getElementById(`unit-price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const sourceUnit = html.getElementById(`unit-price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuGoal = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const invGoal = document.getElementById(`Inventory-${this.dataset.section}`);
        const stickyPrice = document.getElementById(`StickyAtcPrice-${this.dataset.section}`);
        if (source && goal) goal.innerHTML = source.innerHTML;
        if (source && stickyPrice) {
          stickyPrice.innerHTML = source.innerHTML;
          stickyPrice.className = `sticky-btn-atc__price ${source.className}`;
          stickyPrice.classList.remove('visibility-hidden');
        }
        if (sourceUnit && goalUnit) goalUnit.innerHTML = sourceUnit.innerHTML;
        if (inventorySource && invGoal) invGoal.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuGoal) {
          skuGoal.innerHTML = skuSource.innerHTML;
          skuGoal.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }
        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove('visibility-hidden');
        if (stickyPrice) stickyPrice.classList.remove('visibility-hidden');
        if (inventorySource && invGoal) invGoal.classList.toggle('visibility-hidden', inventorySource.innerText === '');
        const cartBtUpdated = html.getElementById(`ProductSubmitButton-${stScId}`);
        const cartBtUpdatedLabel = cartBtUpdated ? cartBtUpdated.textContent.trim() : '';
        this.btAddButton(
          cartBtUpdated ? cartBtUpdated.hasAttribute('disabled') : true,
          cartBtUpdatedLabel || window.stThemeString.Strsoldout
        );
        const container = document.querySelector('[data-store-availability-container]');
        // fetch(`${window.Shopify.routes.root}variants/${reqSwatchId}/?section_id=pickup-availability`)
        //   .then(response => {
        //     if (!response.ok) throw new Error('Failed to fetch pickup availability.');
        //     return response.text();
        //   })
        //   .then(text => {
        //     const parsedHTML = new DOMParser().parseFromString(text, 'text/html');
        //     const availabilitySection = parsedHTML.querySelector('.shopify-section');
        //     if (availabilitySection) {
        //       const unavailablePickupOptions = availabilitySection.querySelectorAll('.unavailable');
        //       if (unavailablePickupOptions.length > 0) {
        //         console.log(`Variant ${reqSwatchId} has unavailable pickup options.`);
        //         unavailablePickupOptions.forEach(option => {
        //           console.log('Unavailable location:', option.textContent.trim());
        //         });
        //       } else {
        //         console.log(`Variant ${reqSwatchId} has all pickup options available.`);
        //       }
        //     } else {
        //       console.log(`No pickup availability information found for variant ${reqSwatchId}.`);
        //     }
        //   })
        //   .catch(error => {
        //     console.error('Error fetching pickup availability:', error);
        //   });
        fetch(window.Shopify.routes.root + "variants/" + reqSwatchId + "/?section_id=pickup-availability")
          .then(response => response.text())
          .then(text => {
            if (!container) {
              console.error('Pickup availability container not found.');
              return;
            }
            const pickupAvailabilityHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');
            if (!pickupAvailabilityHTML) {
              console.error('Pickup availability HTML not found.');
              return;
            }
            // console.log(pickupAvailabilityHTML);
            // container.innerHTML = '';
            // container.appendChild(pickupAvailabilityHTML);
            // const button = document.querySelector('#ShowPickupAvailabilityDrawer');
            // if (button)
            //   button.addEventListener('click', (evt) => {
            //     document.querySelector('pickup-availability-drawer').show(evt.target);
            //   });
            const unavailablePickupOptions = pickupAvailabilityHTML.querySelectorAll('.unavailable');
            const elementsToHide = document.querySelectorAll('.product__pickup-availabilities.quick-add-hidden');
            if (unavailablePickupOptions.length > 0) {
              // Loop through and hide each element
              elementsToHide.forEach(element => {
                element.style.display = 'none';
              });
            } else {
              // Loop through and hide each element
              elementsToHide.forEach(element => {
                element.style.display = 'block';
              });
              container.innerHTML = '';
              container.appendChild(pickupAvailabilityHTML);
              const button = document.querySelector('#ShowPickupAvailabilityDrawer');
              if (button) {
                button.addEventListener('click', evt => {
                  const drawer = document.querySelector('pickup-availability-drawer');
                  if (drawer && typeof drawer.show === 'function') {
                    drawer.show(evt.target);
                  } else {
                    console.error('Drawer element or show method not found.');
                  }
                });
              }
            }
          })
          .catch(e => {
            console.error(e);
          });
        live(SP_OBJECT.swatchUpdate, {
          data: {
            stScId,
            html,
            variant: this.swatch
          }
        });
      });
  }
  btAddButton(disable = true, text, modifyClass = true) {
    const stproductForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-sticky-${this.dataset.section}`);
    if (!stproductForms.length) return;
    stproductForms.forEach((stproductForm) => {
      const cartBt = stproductForm.querySelector('[name="add"]');
      const cartBtText = stproductForm.querySelector('[name="add"] > span');
      if (!cartBt || !cartBtText) return;
      if (disable) {
        cartBt.setAttribute('disabled', 'disabled');
        if (text) {
          cartBtText.textContent = text;
        }
      } else {
        cartBt.removeAttribute('disabled');
        cartBtText.textContent = window.stThemeString.Straddcart;
      }
    });
    if (!modifyClass) return;
  }
  stInaccessible() {
    const mainForm = document.getElementById(`product-form-${this.dataset.section}`);
    const price = document.getElementById(`price-${this.dataset.section}`);
    const stickyPrice = document.getElementById(`StickyAtcPrice-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    this.btAddButton(true, window.stThemeString.Strunavailable, false);
    if (!mainForm) return;
    if (price) price.classList.add('visibility-hidden');
    if (stickyPrice) stickyPrice.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }
  stSwatchDate() {
    const variantJson = this.querySelector('[type="application/json"]');
    if (!variantJson) return this.variantData || [];
    this.variantData = this.variantData || JSON.parse(variantJson.textContent);
    return this.variantData;
  }
}
customElements.define('selects-box', Swatchoption);
class SwatchCheck extends Swatchoption {
  constructor() {
    super();
  }
  stInAva(stlistOfOptions, stlistOfAvOptions) {
    stlistOfOptions.forEach(input => {
      if (stlistOfAvOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }
  itemsUpdate() {
    const varitems = Array.from(this.querySelectorAll('varitem'));
    this.options = varitems.map((varitem) => {
      const checkedRadio = Array.from(varitem.querySelectorAll('input')).find((radio) => radio.checked);
      return checkedRadio ? checkedRadio.value : null;
    });
  }
}
customElements.define('pr-option', SwatchCheck);
class StRecomPro extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const sthandleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommrela = html.querySelector('relative-pro');
          if (recommrela && recommrela.innerHTML.trim().length) {
            this.innerHTML = recommrela.innerHTML;
            var slide_view = jQuery('#related-slider').attr('slide-view');
            var slide_view_lg = jQuery('#related-slider').attr('slide-view-lg');
            var slide_view_sm = jQuery('#related-slider').attr('slide-view-sm');
            var swiper = new Swiper('#related-slider', {
              slidesPerView: slide_view,
              grid: {
                rows: 1,
                fill: 'row',
              },
              spaceBetween: 30,
              observer: true,
              observeParents: true,
              watchSlidesProgress: true,
              navigation: {
                nextEl: '.swiper-next',
                prevEl: '.swiper-prev',
              },
              pagination: {
                el: ".swiper-pagination",
                clickable: true
              },
              breakpoints: {
                0: {
                  slidesPerView: 1,
                  grid: {
                    rows: 1,
                    fill: 'row',
                  },
                  spaceBetween: 12
                },
                320: {
                  slidesPerView: 1,
                  grid: {
                    rows: 1,
                    fill: 'row',
                  },
                  spaceBetween: 12
                },
                360: {
                  slidesPerView: slide_view_sm,
                  grid: {
                    rows: 1,
                    fill: 'row',
                  },
                  spaceBetween: 12
                },
                540: {
                  slidesPerView: slide_view_sm,
                  grid: {
                    rows: 1,
                    fill: 'row',
                  },
                  spaceBetween: 12
                },
                640: {
                  slidesPerView: slide_view_sm,
                  grid: {
                    rows: 1,
                    fill: 'row',
                  },
                  spaceBetween: 12
                },
                768: {
                  slidesPerView: slide_view_sm,
                  grid: {
                    rows: 1,
                    fill: 'row',
                  },
                  spaceBetween: 30
                },
                1024: {
                  slidesPerView: slide_view_lg,
                  grid: {
                    rows: 1,
                    fill: 'row',
                  },
                  spaceBetween: 30
                },
                1199: {
                  slidesPerView: slide_view,
                  grid: {
                    rows: 1,
                    fill: 'row',
                  },
                  spaceBetween: 30
                },
                1499: {
                  slidesPerView: slide_view,
                  grid: {
                    rows: 1,
                    fill: 'row',
                  },
                  spaceBetween: 30
                }
              }
            });
          }
          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };
    new IntersectionObserver(sthandleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}
customElements.define('relative-pro', StRecomPro);
class ajaxSearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    if (this.input) {
      if (this.input.form) {
        this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      }
      this.input.addEventListener(
        'input',
        stdebounce((event) => {
          this.triggerChange(event);
        }, 300).bind(this)
      );
    }
  }
  ajaxResetBtn() {
    if (!this.resetButton || !this.input) return;
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }
  triggerChange() {
    this.ajaxResetBtn();
  }
  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }
  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the ajax search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.ajaxResetBtn();
    }
  }
}
customElements.define('search-form', ajaxSearchForm);
if (!customElements.get('popup-view')) {
  customElements.define('popup-view', class QuickAddModal extends stModalcontent {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }
    hide(preventFocus = false) {
      this.modalContent.innerHTML = '';
      if (preventFocus) this.openedBy = null;
      super.hide();
    }
    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      const openerLoader = opener.querySelector('.ajax-loader');
      if (openerLoader) openerLoader.classList.remove('hidden');
      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          if (!this.productElement) return;
          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);
          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) window.ProductModel.loadShopifyXR();
          this.preSwatchURLswapping();
          super.show(opener);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          if (openerLoader) openerLoader.classList.add('hidden');
        });
    }
    setInnerHTML(element, html) {
      element.innerHTML = html;
      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }
    preSwatchURLswapping() {
      const variantPicker = this.modalContent.querySelector('pr-option,selects-box');
      if (!variantPicker) return;
      variantPicker.setAttribute('data-update-url', 'false');
    }
    removeDOMElements() {
      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();
      const modalDialog = this.productElement.querySelectorAll('modal-dialog');
      if (modalDialog) modalDialog.forEach(modal => modal.remove());
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();
    }
    preventDuplicatedIDs() {
      const stScId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(stScId, `quickadd-${stScId}`);
      this.productElement.querySelectorAll('selects-box, pr-option, product-info').forEach((element) => {
        element.dataset.originalSection = stScId;
      });
    }
  });
}
if (!customElements.get('product-bundle-offer')) {
  customElements.define('product-bundle-offer', class ProductBundleOffer extends HTMLElement {
    constructor() {
      super();
      this.currentVariantId = this.dataset.selectedVariantId || '';
      this.touchedSelects = new WeakSet();
      this.lastOfferQuantity = null;
    }
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.offerInputs = Array.from(this.querySelectorAll('[data-bundle-offer-input]'));
      this.cards = Array.from(this.querySelectorAll('[data-bundle-card]'));
      this.panel = this.querySelector('[data-bundle-panel]');
      this.panelTitle = this.querySelector('[data-bundle-panel-title]');
      this.packRows = Array.from(this.querySelectorAll('[data-bundle-pack-row]'));
      this.packSelects = Array.from(this.querySelectorAll('[data-bundle-pack-select]'));
      this.variantData = this.parseVariants();
      this.selectAnimationTimers = new WeakMap();
      this.customSelectBySelect = new WeakMap();
      const section = this.closest('section');
      if (section) section.classList.add('locarno-bundle-offer--enabled');
      this.initCustomSelects();

      this.offerInputs.forEach((input) => {
        input.addEventListener('change', () => {
          if (!input.checked) return;
          this.resetPackSelections();
          this.update();
        });
      });

      this.packSelects.forEach((select) => {
        select.addEventListener('change', () => {
          this.touchedSelects.add(select);
          this.animateSelectChange(select);
          this.updateCustomSelectLabel(select);
          this.updatePriceSummaries();
        });
      });

      this.bindVariantInputs();
      if (typeof user === 'function' && typeof SP_OBJECT !== 'undefined') {
        this.variantChangeUnuser = user(SP_OBJECT.swatchUpdate, (event) => {
          const data = event && event.data ? event.data : {};
          if (!data.variant || String(data.stScId) !== String(this.sectionId)) return;
          this.updateCurrentVariant(data.variant.id);
        });
      }

      this.update();
    }
    disconnectedCallback() {
      if (this.variantChangeUnuser) this.variantChangeUnuser();
      if (this.closeCustomSelectHandler) document.removeEventListener('click', this.closeCustomSelectHandler);
      if (this.boundVariantInputs) {
        this.boundVariantInputs.forEach((input) => {
          input.removeEventListener('change', this.boundVariantInputHandler);
        });
      }
    }
    parseVariants() {
      const json = this.querySelector('[data-bundle-variants]');
      if (!json) return [];
      try {
        return JSON.parse(json.textContent);
      } catch (error) {
        return [];
      }
    }
    initCustomSelects() {
      const customSelects = Array.from(this.querySelectorAll('[data-bundle-custom-select]'));
      if (!customSelects.length) return;

      this.classList.add('is-custom-select-ready');
      this.closeCustomSelectHandler = (event) => {
        if (!this.contains(event.target)) this.closeCustomSelects();
      };
      document.addEventListener('click', this.closeCustomSelectHandler);

      customSelects.forEach((customSelect) => {
        const select = document.getElementById(customSelect.dataset.for);
        const button = customSelect.querySelector('[data-bundle-custom-select-button]');
        const list = customSelect.querySelector('[data-bundle-custom-select-list]');
        const options = Array.from(customSelect.querySelectorAll('[data-bundle-custom-select-option]'));
        if (!select || !button || !list) return;

        this.customSelectBySelect.set(select, { customSelect, button, list, options });
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.toggleCustomSelect(select);
        });
        customSelect.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            this.closeCustomSelect(select);
            button.focus();
          }
        });
        options.forEach((option) => {
          option.addEventListener('click', (event) => {
            event.preventDefault();
            if (option.disabled) return;
            select.value = option.dataset.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            this.closeCustomSelect(select);
            button.focus();
          });
        });

        this.updateCustomSelectLabel(select);
      });
    }
    toggleCustomSelect(select) {
      const custom = this.customSelectBySelect.get(select);
      if (!custom) return;
      const shouldOpen = !custom.customSelect.classList.contains('is-open');
      this.closeCustomSelects();
      if (!shouldOpen) return;
      custom.customSelect.classList.add('is-open');
      custom.button.setAttribute('aria-expanded', 'true');
      custom.list.hidden = false;
    }
    closeCustomSelect(select) {
      const custom = this.customSelectBySelect.get(select);
      if (!custom) return;
      custom.customSelect.classList.remove('is-open');
      custom.button.setAttribute('aria-expanded', 'false');
      custom.list.hidden = true;
    }
    closeCustomSelects() {
      this.packSelects.forEach((select) => this.closeCustomSelect(select));
    }
    updateCustomSelectLabel(select) {
      const custom = this.customSelectBySelect.get(select);
      if (!custom) return;
      const selectedOption = Array.from(select.options).find((option) => option.value === select.value);
      const selectedCustomOption = custom.options.find((option) => option.dataset.value === select.value);
      const label = selectedCustomOption ? selectedCustomOption.dataset.label : selectedOption ? selectedOption.textContent.trim() : '';
      const labelElement = custom.button.querySelector('[data-bundle-custom-select-label]');
      if (labelElement && label) labelElement.textContent = label;
      custom.options.forEach((option) => {
        option.setAttribute('aria-selected', option.dataset.value === select.value ? 'true' : 'false');
      });
    }
    bindVariantInputs() {
      this.boundVariantInputHandler = (event) => {
        if (event.target && event.target.value) this.updateCurrentVariant(event.target.value);
      };
      this.boundVariantInputs = [
        document.getElementById(this.dataset.productFormId),
        document.getElementById(`product-form-sticky-${this.sectionId}`)
      ].filter(Boolean).map((form) => form.querySelector('input[name="id"]')).filter(Boolean);
      this.boundVariantInputs.forEach((input) => {
        input.addEventListener('change', this.boundVariantInputHandler);
      });
    }
    getOfferQuantity() {
      const activeInput = this.offerInputs.find((input) => input.checked);
      return activeInput ? parseInt(activeInput.value, 10) || 1 : 1;
    }
    getActiveInput() {
      return this.offerInputs.find((input) => input.checked) || null;
    }
    getDiscountPercent(input = this.getActiveInput()) {
      const discount = input ? parseFloat(input.dataset.bundleDiscountPercent) : 0;
      return Number.isFinite(discount) ? Math.max(0, Math.min(100, discount)) : 0;
    }
    getVariantById(variantId) {
      const requestedId = String(variantId || '');
      return this.variantData.find((variant) => String(variant.id) === requestedId) || null;
    }
    getVariantRegularPrice(variant) {
      const price = Number(variant && variant.price ? variant.price : 0);
      const compareAtPrice = Number(variant && variant.compare_at_price ? variant.compare_at_price : 0);
      return compareAtPrice > price && compareAtPrice > 0 ? compareAtPrice : price;
    }
    getVariantOriginalDiscountPercent(variant) {
      const price = Number(variant && variant.price ? variant.price : 0);
      const regularPrice = this.getVariantRegularPrice(variant);
      if (!regularPrice || regularPrice <= price) return 0;
      return Math.round(((regularPrice - price) * 100) / regularPrice);
    }
    getSelectedVariantIds(quantity, usePackSelections = true) {
      if (quantity <= 1 || !usePackSelections) {
        return Array(quantity).fill(this.currentVariantId || this.getFirstAvailableVariantId()).filter(Boolean);
      }
      return this.packRows.slice(0, quantity).map((row) => {
        const select = row.querySelector('[data-bundle-pack-select]');
        return select && select.value ? select.value : this.currentVariantId;
      }).filter(Boolean);
    }
    getBundlePriceData(quantity, discountPercent, usePackSelections = true) {
      const totals = this.getSelectedVariantIds(quantity, usePackSelections).reduce((data, variantId) => {
        const variant = this.getVariantById(variantId);
        const price = Number(variant && variant.price ? variant.price : 0);
        const regularPrice = this.getVariantRegularPrice(variant);
        const originalDiscountPercent = this.getVariantOriginalDiscountPercent(variant);
        const totalDiscountPercent = Math.min(100, originalDiscountPercent + discountPercent);

        data.regularTotal += regularPrice;
        data.saleTotal += discountPercent > 0 ? Math.round(regularPrice * (100 - totalDiscountPercent) / 100) : price;
        return data;
      }, {
        regularTotal: 0,
        saleTotal: 0
      });
      totals.totalDiscountPercent = totals.regularTotal > 0
        ? Math.round(((totals.regularTotal - totals.saleTotal) * 100) / totals.regularTotal)
        : 0;
      return totals;
    }
    formatMoney(cents) {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, window.money_format || '${{amount}}');
      }
      return (cents / 100).toFixed(2);
    }
    animateSelectChange(select) {
      if (!select) return;
      select.classList.remove('is-changing');
      void select.offsetWidth;
      select.classList.add('is-changing');
      clearTimeout(this.selectAnimationTimers.get(select));
      this.selectAnimationTimers.set(select, setTimeout(() => {
        select.classList.remove('is-changing');
      }, 360));
    }
    getFirstAvailableVariantId() {
      const firstAvailable = this.variantData.find((variant) => variant.available);
      return firstAvailable ? String(firstAvailable.id) : this.currentVariantId;
    }
    setSelectToVariant(select, variantId) {
      if (!select) return;
      const requestedValue = String(variantId || '');
      const requestedOption = Array.from(select.options).find((option) => option.value === requestedValue && !option.disabled);
      if (requestedOption) {
        select.value = requestedOption.value;
        this.updateCustomSelectLabel(select);
        return;
      }
      const fallbackOption = Array.from(select.options).find((option) => !option.disabled);
      if (fallbackOption) {
        select.value = fallbackOption.value;
        this.updateCustomSelectLabel(select);
      }
    }
    resetPackSelections() {
      const nextVariantId = this.currentVariantId || this.getFirstAvailableVariantId();
      this.packSelects.forEach((select) => {
        this.touchedSelects.delete(select);
        this.setSelectToVariant(select, nextVariantId);
      });
    }
    updateCurrentVariant(variantId) {
      this.currentVariantId = String(variantId || this.currentVariantId || '');
      if (this.getOfferQuantity() > 1) {
        this.packSelects.forEach((select) => {
          if (!this.touchedSelects.has(select)) this.setSelectToVariant(select, this.currentVariantId);
        });
      }
      this.updateButtonLabels();
      this.updatePriceSummaries();
    }
    update() {
      const quantity = this.getOfferQuantity();
      const isBundle = quantity > 1;
      const offerQuantityChanged = this.lastOfferQuantity !== null && this.lastOfferQuantity !== quantity;
      const section = this.closest('section');

      this.cards.forEach((card) => {
        const input = card.querySelector('[data-bundle-offer-input]');
        card.classList.toggle('is-active', Boolean(input && input.checked));
      });

      if (this.panel) this.panel.hidden = !isBundle;
      if (offerQuantityChanged && isBundle) this.animateBundlePanel();
      if (this.panelTitle) {
        this.panelTitle.textContent = quantity === 3 ? this.panelTitle.dataset.threeTitle : this.panelTitle.dataset.twoTitle;
      }
      this.packRows.forEach((row) => {
        const rowIndex = parseInt(row.dataset.bundlePackRow, 10) || 0;
        row.hidden = !isBundle || rowIndex > quantity;
      });
      if (offerQuantityChanged && isBundle) {
        this.packRows.slice(0, quantity).forEach((row, index) => {
          const select = row.querySelector('[data-bundle-pack-select]');
          if (!select) return;
          setTimeout(() => this.animateSelectChange(select), 70 + (index * 70));
        });
      }
      if (section) section.classList.toggle('locarno-bundle-offer--multi', isBundle);
      this.lastOfferQuantity = quantity;
      this.updateButtonLabels();
      this.updatePriceSummaries();
    }
    animateBundlePanel() {
      if (!this.panel) return;
      this.panel.classList.remove('is-switching');
      void this.panel.offsetWidth;
      this.panel.classList.add('is-switching');
      clearTimeout(this.panelAnimationTimer);
      this.panelAnimationTimer = setTimeout(() => {
        if (this.panel) this.panel.classList.remove('is-switching');
      }, 540);
    }
    updatePriceSummaries() {
      this.cards.forEach((card) => {
        const input = card.querySelector('[data-bundle-offer-input]');
        if (!input) return;
        const quantity = parseInt(input.value, 10) || 1;
        const discountPercent = this.getDiscountPercent(input);
        const priceData = this.getBundlePriceData(quantity, discountPercent, input.checked);
        const regularPrice = card.querySelector('[data-bundle-regular-price]');
        const salePrice = card.querySelector('[data-bundle-sale-price]');
        const discountLabel = card.querySelector('[data-bundle-discount-label]');

        if (salePrice) salePrice.textContent = this.formatMoney(priceData.saleTotal);
        if (regularPrice) {
          regularPrice.textContent = this.formatMoney(priceData.regularTotal);
          regularPrice.hidden = priceData.totalDiscountPercent <= 0 || priceData.saleTotal >= priceData.regularTotal;
        }
        if (discountLabel) {
          discountLabel.textContent = `-${priceData.totalDiscountPercent}%`;
          discountLabel.hidden = priceData.totalDiscountPercent <= 0;
        }
      });
    }
    updateButtonLabels() {
      const quantity = this.getOfferQuantity();
      const label = quantity === 3
        ? this.dataset.addThreeLabel
        : quantity === 2
          ? this.dataset.addTwoLabel
          : (window.stThemeString && window.stThemeString.Straddcart) || this.dataset.addOneLabel;
      const forms = [
        document.getElementById(this.dataset.productFormId),
        document.getElementById(`product-form-sticky-${this.sectionId}`)
      ].filter(Boolean);

      forms.forEach((form) => {
        const button = form.querySelector('[name="add"]');
        const buttonText = button ? button.querySelector('.cart-title') : null;
        if (!button || !buttonText || button.disabled) return;
        buttonText.textContent = label;
      });
    }
    getBundleItems() {
      const quantity = this.getOfferQuantity();
      if (quantity <= 1) return null;
      const activeInput = this.offerInputs.find((input) => input.checked);
      const bundleDiscountPercent = this.getDiscountPercent(activeInput);
      const priceData = this.getBundlePriceData(quantity, bundleDiscountPercent, true);
      const offerDiscount = priceData.totalDiscountPercent > 0 ? `-${priceData.totalDiscountPercent}%` : '';
      const offerDiscountPercent = priceData.totalDiscountPercent > 0 ? String(priceData.totalDiscountPercent) : '';

      const lineItems = {};
      this.packRows.slice(0, quantity).forEach((row) => {
        const select = row.querySelector('[data-bundle-pack-select]');
        if (!select || !select.value) return;
        const variantId = String(select.value);
        lineItems[variantId] = (lineItems[variantId] || 0) + 1;
      });

      const items = Object.keys(lineItems).map((variantId) => {
        const properties = {
          _locarno_bundle_offer: `${quantity}-pack`,
          _locarno_bundle_section: this.sectionId
        };
        if (offerDiscount) properties._locarno_bundle_discount = offerDiscount;
        if (offerDiscountPercent) properties._locarno_bundle_discount_percent = offerDiscountPercent;

        return {
          id: Number(variantId),
          quantity: lineItems[variantId],
          properties
        };
      });

      return items.length ? items : null;
    }
  });
}
if (!customElements.get('cart-action')) {
  customElements.define('cart-action', class stProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      if (!this.form) return;
      const idInput = this.form.querySelector('[name=id]');
      if (idInput) idInput.disabled = false;
      this.form.addEventListener('submit', this.triggerSendHand.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('ajax-cart');
      this.submitButton = this.querySelector('[type="submit"]');
    }
    getBundleOffer() {
      const formId = this.form ? this.form.getAttribute('id') : '';
      if (!formId) return null;
      let sectionId = formId.replace(/^product-form-sticky-/, '').replace(/^product-form-/, '');
      const bundleOffers = Array.from(document.querySelectorAll('product-bundle-offer'));
      return bundleOffers.find((bundleOffer) => String(bundleOffer.dataset.sectionId) === String(sectionId)) || null;
    }
    buildBundlePayload() {
      const bundleOffer = this.getBundleOffer();
      if (!bundleOffer || typeof bundleOffer.getBundleItems !== 'function') return null;
      const items = bundleOffer.getBundleItems();
      if (!items) return null;
      return { items };
    }
    cartAddUrl(useJsonEndpoint = false) {
      const url = (window.routes && window.routes.increase_cart_url) || '/cart/add';
      if (!useJsonEndpoint || /\.js($|\?)/.test(url)) return url;
      return `${url}.js`;
    }
    cartUrl() {
      return (window.routes && window.routes.cart_url) || '/cart';
    }
    triggerSendHand(evt) {
      evt.preventDefault();
      if (!this.submitButton) return;
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      this.stHandErrorTxt();
      this.error = false;
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      const formLoader = this.querySelector('.ajax-loader');
      if (formLoader) formLoader.classList.remove('hidden');
      try {
        const bundlePayload = this.buildBundlePayload();
        if (bundlePayload) {
          const config = stFetchConfig();
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          if (this.cart && typeof this.cart.fetchSecToInclude === 'function') {
            bundlePayload.sections = this.cart.fetchSecToInclude().map((section) => section.id);
            bundlePayload.sections_url = window.location.pathname;
          }
          if (this.cart && typeof this.cart.setActiveElement === 'function') {
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = JSON.stringify(bundlePayload);
          this.submitCartRequest(config, formLoader, true);
          return;
        }
        const config = stFetchConfig();
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData(this.form);
        if (this.cart && typeof this.cart.fetchSecToInclude === 'function') {
          formData.append('sections', this.cart.fetchSecToInclude().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
        }
        if (this.cart && typeof this.cart.setActiveElement === 'function') {
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        this.submitCartRequest(config, formLoader, true);
      } catch (e) {
        console.error(e);
        this.error = false;
        this.stHandErrorTxt(e && e.message ? e.message : (window.stCartString ? window.stCartString.error : 'Unable to add to cart.'));
        this.resetSubmitState(formLoader);
      }
    }
    parseCartResponse(response) {
      return response.text().then((text) => {
        let parsedResponse;
        try {
          parsedResponse = JSON.parse(text);
        } catch (error) {
          throw new Error(window.stCartString ? window.stCartString.error : 'Unable to add to cart.');
        }
        if (!response.ok) {
          const message = parsedResponse.description || parsedResponse.message || (window.stCartString ? window.stCartString.error : 'Unable to add to cart.');
          throw new Error(message);
        }
        return parsedResponse;
      });
    }
    refreshCartBadge() {
      return fetch(`${this.cartUrl()}?section_id=ajax-cart-icon`, { cache: 'no-store' })
        .then((response) => response.text())
        .then((html) => {
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const badge = parsed.querySelector('.bigcounter');
          if (!badge) return;
          document.querySelectorAll('#ajax-cart-icon, #ajax-cart-icon-redesign').forEach((element) => {
            const currentBadge = element.querySelector('.bigcounter');
            if (currentBadge) currentBadge.innerHTML = badge.innerHTML;
          });
        });
    }
    refreshCartDrawer() {
      const cartDrawer = document.querySelector('ajax-cart');
      if (!cartDrawer) return Promise.resolve();
      return fetch(`${this.cartUrl()}?section_id=ajax-cart`, { cache: 'no-store' })
        .then((response) => response.text())
        .then((html) => {
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const freshDrawer = parsed.querySelector('ajax-cart');
          const currentDrawer = cartDrawer.querySelector('#ajaxcart');
          const nextDrawer = freshDrawer && freshDrawer.querySelector('#ajaxcart');
          if (!freshDrawer || !currentDrawer || !nextDrawer) return;
          cartDrawer.classList.toggle('is-empty', freshDrawer.classList.contains('is-empty'));
          currentDrawer.innerHTML = nextDrawer.innerHTML;
          const overlay = cartDrawer.querySelector('#ajaxcart-overlay');
          if (overlay) overlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));
        });
    }
    refreshCartUi() {
      return Promise.allSettled([
        this.refreshCartBadge(),
        this.refreshCartDrawer()
      ]).then(() => {});
    }
    finishSuccessfulCartAdd() {
      if (!this.cart) {
        window.location = this.cartUrl();
        return Promise.resolve();
      }

      const quickAddModal = this.closest('popup-view');
      if (quickAddModal) quickAddModal.hide(true);

      return this.refreshCartUi().then(() => {
        live(SP_OBJECT.ajxcartRefresh, { source: 'cart-action' });
        if (typeof this.cart.open === 'function') this.cart.open();
      });
    }
    submitBundleCartRequest(bundlePayload, formLoader) {
      const config = stFetchConfig();
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify(bundlePayload);

      fetch(this.cartAddUrl(true), config)
        .then((response) => this.parseCartResponse(response))
        .then(() => this.finishSuccessfulCartAdd())
        .catch((e) => {
          console.error(e);
          this.error = false;
          this.stHandErrorTxt(e && e.message ? e.message : (window.stCartString ? window.stCartString.error : 'Unable to add to cart.'));
        })
        .finally(() => {
          this.resetSubmitState(formLoader);
        });
    }
    submitSingleCartRequest(config, formLoader) {
      fetch(this.cartAddUrl(true), config)
        .then((response) => this.parseCartResponse(response))
        .then(() => this.finishSuccessfulCartAdd())
        .catch((e) => {
          console.error(e);
          this.error = false;
          this.stHandErrorTxt(e && e.message ? e.message : (window.stCartString ? window.stCartString.error : 'Unable to add to cart.'));
        })
        .finally(() => {
          this.resetSubmitState(formLoader);
        });
    }
    submitCartRequest(config, formLoader, useJsonEndpoint = false) {
      fetch(this.cartAddUrl(useJsonEndpoint), config)
        .then((response) => this.parseCartResponse(response))
        .then((response) => {
          if (response.status) {
            this.stHandErrorTxt(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) {
              this.error = false;
              return;
            }
            this.submitButton.setAttribute('aria-disabled', true);
            const submitButtonText = this.submitButton.querySelector('span');
            if (submitButtonText) submitButtonText.classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = this.cartUrl();
            return;
          }
          this.error = false;
          const renderCart = () => {
            if (response.sections && typeof this.cart.renderContents === 'function') {
              this.cart.renderContents(response);
              return;
            }
            this.finishSuccessfulCartAdd();
          };
          const quickAddModal = this.closest('popup-view');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(renderCart);
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            renderCart();
          }
        })
        .catch((e) => {
          console.error(e);
          this.error = false;
          this.stHandErrorTxt(e && e.message ? e.message : (window.stCartString ? window.stCartString.error : 'Unable to add to cart.'));
        })
        .finally(() => {
          this.resetSubmitState(formLoader);
        });
    }
    resetSubmitState(formLoader) {
      if (this.submitButton) {
        this.submitButton.classList.remove('loading');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
      }
      if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
      if (formLoader) formLoader.classList.add('hidden');
    }
    stHandErrorTxt(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.pr-form-error');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.pr-form-error-text');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }
  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const template = this.querySelector('template');
      if (!template || !template.content.firstElementChild) return;
      const content = document.createElement('div');
      content.appendChild(template.content.firstElementChild.cloneNode(true));
      this.setAttribute('loaded', true);
      const mediaElement = content.querySelector('video, model-viewer, iframe');
      if (!mediaElement) return;
      const deferredElement = this.appendChild(mediaElement);
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}
customElements.define('deferred-media', DeferredMedia);
